import { createContext, useContext, ReactNode, useState, useMemo, ReactElement } from 'react';

interface AppContextType {
  isDropdownOpen: boolean;
  setDropdownOpen: (value: boolean) => void;
}

const AppContext = createContext<AppContextType | undefined>(undefined);

interface AppProviderProps {
  children: ReactNode;
}

export const AppProvider = ({ children }: AppProviderProps): ReactElement => {
  const [isDropdownOpen, setDropdownOpen] = useState(false);

  const value = useMemo(
    () => ({
      isDropdownOpen,
      setDropdownOpen,
    }),
    [isDropdownOpen]
  );

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

export const useAppContext = (): AppContextType => {
  const context = useContext(AppContext);
  if (context === undefined) {
    throw new Error('useAppContext must be used within an AppProvider');
  }
  return context;
};
